import { oc } from "@orpc/contract";
import { z } from "zod";
import { CreateDocumentFolderInputSchema, UpdateDocumentFolderInputSchema, DocumentFolderResponseSchema, DocumentFolderOwnerTypeSchema, } from "@hourly/api/documentFolder";
// ===== ENDPOINTS =====
const createDocumentFolder = oc
    .route({
    method: "POST",
    path: "/document-folders",
    summary: "Create a document folder",
    tags: ["Document Folders"],
})
    .input(CreateDocumentFolderInputSchema)
    .output(DocumentFolderResponseSchema);
const getDocumentFolder = oc
    .route({
    method: "GET",
    path: "/document-folders/{id}",
    summary: "Get a document folder by ID",
    tags: ["Document Folders"],
})
    .input(z.object({ id: z.uuid() }))
    .output(DocumentFolderResponseSchema);
const listDocumentFolders = oc
    .route({
    method: "GET",
    path: "/document-folders",
    summary: "List document folders",
    tags: ["Document Folders"],
})
    .input(z.object({
    ownerType: DocumentFolderOwnerTypeSchema.optional(),
    employmentId: z.uuid().optional(),
    parentId: z.uuid().nullable().optional(),
    asTree: z.union([z.literal("true"), z.literal("false"), z.boolean()]).optional().default(false).transform((val) => val === "true" || val === true),
}))
    .output(z.array(DocumentFolderResponseSchema.passthrough())); // Allow extra properties (like children for tree nodes)
const updateDocumentFolder = oc
    .route({
    method: "PATCH",
    path: "/document-folders/{id}",
    summary: "Update a document folder",
    tags: ["Document Folders"],
})
    .input(z.object({
    id: z.uuid(),
}).merge(UpdateDocumentFolderInputSchema))
    .output(DocumentFolderResponseSchema);
const deleteDocumentFolder = oc
    .route({
    method: "DELETE",
    path: "/document-folders/{id}",
    summary: "Delete a document folder",
    tags: ["Document Folders"],
})
    .input(z.object({ id: z.uuid() }))
    .output(z.object({ success: z.boolean() }));
// ===== CONTRACT =====
export const documentFolderContract = {
    create: createDocumentFolder,
    get: getDocumentFolder,
    list: listDocumentFolders,
    update: updateDocumentFolder,
    delete: deleteDocumentFolder,
};
//# sourceMappingURL=documentFolder.js.map